import { Button, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import UserForm from './UserForm'
import { useForm } from 'antd/es/form/Form'
import { deleteRequest, get, post } from '../../Common/api'
import { Color } from '../../Common/Color'
import UsersTab from './UsersTab'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'
import { ActionButton } from '../../Common/Common'

export default function UsersPage () {
  const [activeUsers, setActiveUsers] = useState([])
  const [deletedUsers, setDeletedUsers] = useState([])
  const [owners, setOwners] = useState()
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getUsers()
  }, [])

  const getUsers = async () => {
    setLoading(true)
    await get({
      url: 'admin/users',
      params: {},
      onSuccess: (res) => {
        setLoading(false)
        setActiveUsers(res.active)
        setDeletedUsers(res.deleted)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const postUser = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/users',
      params,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: () => {
        setModalVisible(false)
        setLoading(false)
        getUsers()
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  useEffect(() => {
    getOwners()
  }, [])

  const getOwners = async () => {
    setLoading(true)
    await get({
      url: 'admin/owners',
      params: {},
      onSuccess: (res) => {
        setLoading(false)
        setOwners(res)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postUser(values)
  }

  const deleteUser = async (user) => {
    await deleteRequest({
      url: `admin/users/${user.id}`,
      params: {},
      notification: { api: notificationApi, state: 'delete' },
      onSuccess: (res) => {
        const user = activeUsers.find(i => i.id === res.id)
        setActiveUsers(activeUsers.filter(i => i.id !== res.id))
        setDeletedUsers([...deletedUsers, user])
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{activeUsers.length + deletedUsers.length}</b> {t('Admin.UsersPage.title')}</div>
          <ActionButton onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <UsersTab
          activeUsers={activeUsers}
          deletedUsers={deletedUsers}
          deleteUser={deleteUser}
        />
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="350px"
          title={t('Admin.UsersPage.addUserTitle')}
          onOk={form.submit}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <UserForm form={form} onFinish={onAdd} owners={owners}/>
          </Spin>
        </CustModal>
      </Spin>
    </Layout>
  )
}
